import { getRequest, postRequest } from "api/axiosClient";
import { GetTaskResponseType, GetTaskListResponseType } from "api/response";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/task`;

const getTask = (id: string, config = {}) => getRequest<GetTaskResponseType>(`${baseURL}/${id}`, config);
const getTasks = (config = {}) => getRequest<GetTaskListResponseType>(`${baseURL}s`, config);
const submitTask = (id: string, payload: Record<string, string>) => postRequest(`${baseURL}/${id}`, payload);

export { getTask, getTasks, submitTask };
